import { DirectiveBase } from '../angular-directive-base.directive';

/**
 * A pagination component used to retrieve and navigate between pages of a dataset from a server. This directive works by calling it's scope fetchCollection property (this would be a reference to a function in the parent scope), for example when clicking on page number buttons that are rendered by this directive.
 */
export class Paginator extends DirectiveBase {
  constructor() {
    super();
    this.templateUrl = 'app/angularJS/components/paginator/paginator.html';
    this.bindToController = true;
    this.controller = 'PaginatorController';
    this.controllerAs = 'vm';
    this.restrict = 'A';
    this.scope = {
      totalCount: '=',
      perPage: '=',
      fetchCollection: '&',
      paginationData: '=?',
      exportFormats: '=?',
      exportHandler: '&?'
    };
  }
}